export default __webpack_public_path__ + "static/media/BackgroundImage.d21a2a0e.jpg";